/**
 * ProjectView Component
 */

import './project-view.scss';

import * as classNames from 'classnames';
import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { FieldArray } from 'redux-form';

import ProjectTrackList, { IProjectTrackListWrapperProps } from './projectView/ProjectTrackList';

interface IOwnProps extends Pick<IProjectTrackListWrapperProps, 'onSaveLicense' | 'project' | 'license'> {
  className?: string;
}

const classes = new BEM('project-view');

const ProjectView: React.SFC<IOwnProps> = ({
  children,
  className,
  ...passDownProps
}) => (
  <div {...classes('', '', classNames(className))}>
    <div {...classes('tracks-actions')} />
    <FieldArray
      name="activeProject.tracks"
      component={ProjectTrackList}
      props={passDownProps}
    />
  </div>
);

export default ProjectView;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/Projects/ProjectView.tsx